export const COMPANY_INFO = 'company_info'

export const pageBg = {
  technicalStrength: 'https://obs-user-test.obs.cn-east-3.myhuaweicloud.com:443/pictures/test_1731461754_dB684AcGg0.png',
  customerCase: 'https://obs-user-test.obs.cn-east-3.myhuaweicloud.com:443/pictures/test_1731461819_7lK9FTso5q.png',
  productBg: 'https://obs-user-test.obs.cn-east-3.myhuaweicloud.com:443/pictures/test_1731461871_hWuytwGLHP.png',
  newsBg: 'https://obs-user-test.obs.cn-east-3.myhuaweicloud.com:443/pictures/test_1731461914_CNdQSv4mVe.png',
  businessBg: 'https://obs-user-test.obs.cn-east-3.myhuaweicloud.com:443/pictures/test_1731461623_FvKUgAiIsU.png',
}
export const COZE_TOKEN = 'pat_lKQCIgmvGjg5iG41xDTHP508yDKEgpcszaSrpJDcrnf8fKZ1dXI9t5tk68SdKMkM'